enum MK {
    On = 1,
    Off = 0
}

export default MK;